define('widgets/track',[
	'jquery',
	'modules/page',
	'lib/jquery-ui/widget',
	'audiojs',
], function ($, page) {

	return $.widget('muse.track', {

		options: {
		},

		playing: false,

		_create: function () {

			this.audio = this.element.find('audio');
			this.progress = this.element.find('.progress');
			this.loaded = this.element.find('.loaded');

			this._on(page.$win, {
				hashchange: 'onHashChange'
			});

			this.player = audiojs.createAll({
				css: '',
				play: $.proxy(this, 'onPlay'),
				pause: $.proxy(this, 'onPause'),
				updatePlayhead: $.proxy(this, 'onUpdatePlayhead'),
				loadProgress: $.proxy(this, 'onLoadProgress'),
			}, this.audio)[0];

			this._on({
				click: $.proxy(this, 'onClick')
			});

			return this._super();

		},

		onPlay: function () {

			this.element.addClass('started')
				.addClass('playing');

			this.playing = true;

		},

		onPause: function () {

			this.element.removeClass('playing');
			this.playing = false;

		},

		// onTrackEnded: function () {
		// 	this.removeClass('playing');
		// 	this.playing = false;
		// },

		onUpdatePlayhead: function (percent) {

			this.progress.width((percent * 100) + '%');

		},

		onLoadProgress: function (percent) {

			this.loaded.width((percent * 100) + '%');

		},

		onClick: function () {

			if (this.playing)
				this.player.pause();
			else
				this.player.play();

		},

		onHashChange: function (e) {

			var $el = $(location.hash.replace('#!', '#'));
			if (!$el.length || !$el.has(this.element).length)
				this.player.pause();

		}

	});

});
